import { RunningExperiments, useExperiments } from 'state/experiments';

export const useEnableAutoSaveComboSlotChanges = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.AutoSaveComboSlotChanges, 'treatment');
};
